import { ApiErrorResponse } from './types';

/**
 * APIレスポンスからメッセージ候補を抽出する
 */
const pickErrorDetail = (payload: Record<string, unknown>): string => {
  const keys: Array<'detail' | 'message' | 'error'> = ['detail', 'message', 'error'];
  for (const key of keys) {
    const value = payload[key];
    if (typeof value === 'string' && value.trim().length > 0) {
      return value;
    }
  }
  return '';
};

const buildStatusMessage = (response: Response): string =>
  `HTTP ${response.status}: ${response.statusText}`;

/**
 * APIレスポンスからエラーメッセージを取得する
 *
 * @param response - Fetch APIのResponseオブジェクト
 * @returns エラーメッセージ文字列
 */
export async function handleApiError(response: Response): Promise<string> {
  try {
    const text = await response.text();

    if (text) {
      try {
        const body = JSON.parse(text) as ApiErrorResponse | Record<string, unknown>;
        if (body && typeof body === 'object') {
          const detail = pickErrorDetail(body as Record<string, unknown>);
          return detail || text;
        }
        return text;
      } catch {
        return text;
      }
    }

    return buildStatusMessage(response);
  } catch {
    return buildStatusMessage(response);
  }
}

/**
 * HTTPステータスコードに応じた適切なエラーメッセージを返す
 *
 * @param response - Fetch APIのResponseオブジェクト
 * @param defaultMessage - デフォルトのエラーメッセージ
 * @returns エラーメッセージ文字列
 */
export async function getErrorMessage(
  response: Response,
  defaultMessage?: string,
): Promise<string> {
  const detail = await handleApiError(response);

  switch (response.status) {
    case 401:
      return detail || defaultMessage || '認証が期限切れです。再度ログインしてください。';
    case 403:
      return detail || defaultMessage || '権限がありません。管理者に連絡してください。';
    case 404:
      return detail || defaultMessage || 'リソースが見つかりません。';
    case 500:
      return detail || defaultMessage || 'サーバーエラーが発生しました。時間をおいて再度お試しください。';
    default:
      return detail || defaultMessage || `リクエストに失敗しました（HTTP ${response.status}）`;
  }
}
